const tr = {
  settings: 'Tweet Ayarları',
  name: 'Ad - Soyad',
  username: 'Kullanıcı Adı',
  quote: 'Alıntı Tweetler',
  like: 'Beğeni',
  verified: 'Doğrulamış Hesap',
  no_file: 'Dosya Seçilmedi',
  yes: 'Evet',
  no: 'Hayır',
  create: 'Oluştur',
  fetch: 'Bilgieri Getir',
  example_tweet: 'Bu bir örnek tweet...',
  tag: 'kullanici_adi',
  fetch_text: 'Twitter Kullanıcı Adı',
};

const en = {
  settings: 'Tweet Settings',
  name: 'First Name - Last Name',
  username: 'Username',
  quote: 'Quote Tweets',
  like: 'Like',
  verified: 'Verified Account',
  no_file: 'No File Selected',
  yes: 'Yes',
  no: 'No',
  create: 'Create',
  fetch: 'Bring Informations',
  example_tweet: 'This is an example tweet...',
  tag: 'username',
  fetch_text: 'Twitter Username',
};

const lang = {
  tr,
  en,
};

export { lang };
